module.exports = __webpack_public_path__ + "img/351.e888efa6.png";